import axios from 'axios';
import api from 'services/api';
import env from '@utils/env';

const pruneParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  );

class HttpClient {
  constructor() {
    this.baseURL = env.API;
  }

  /**
   * `params` is serialised by axios, so callers no longer have to hand-build a
   * query string. Keys with an undefined or null value are dropped.
   */
  async get(url, params) {
    const config = params ? { params: pruneParams(params) } : undefined;
    const response = await api.get(`${this.baseURL}${url}`, config);

    if (response.data) {
      return response.data;
    }

    throw new Error(`${response.status} - ${response.statusText}`);
  }

  async publicGet(url, params = {}) {
    const usp = new URLSearchParams(params);
    usp.sort();
    let qs = usp.toString();
    qs = qs ? `?${qs}` : '';

    const response = await axios.get(`${this.baseURL}${url}${qs}`, {
      headers: {
        'Request-Type': 'public',
      },
    });

    if (response.data) {
      return response.data;
    }

    throw new Error(`${response.status} - ${response.statusText}`);
  }

  async publicPost(url, data) {
    const response = await fetch(`${this.baseURL}${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const contentType = response.headers.get('content-type') || '';
    const responseData = contentType.includes('application/json')
      ? await response.json()
      : await response.text();

    if (response.status >= 200 && response.status < 300) {
      return responseData;
    }

    const error = new Error(
      responseData?.error || `${response.status} - ${response.statusText}`
    );
    error.response = {
      status: response.status,
      data: responseData,
      headers: Object.fromEntries(response.headers.entries()),
    };
    throw error;
  }

  async post(url, data) {
    const response = await api.post(`${this.baseURL}${url}`, data);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    }

    throw new Error(`${response.status} - ${response.statusText}`);
  }

  async put(url, data) {
    const response = await api.put(`${this.baseURL}${url}`, data);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    }

    throw new Error(`${response.status} - ${response.statusText}`);
  }

  async patch(url, data) {
    const response = await api.patch(`${this.baseURL}${url}`, data);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    }

    throw new Error(`${response.status} - ${response.statusText}`);
  }

  async delete(url) {
    const response = await api.delete(`${this.baseURL}${url}`);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    }

    throw new Error(`${response.status} - ${response.statusText}`);
  }
}

export default HttpClient;
